@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="content">
  <mat-tab-group [mat-stretch-tabs]="false">
    <mat-tab label="Release By Line">
      <line-release [releaseLines]="releaseLines()" (releaseGenerated)="releaseGenerated($event)"></line-release>
    </mat-tab>
    <mat-tab label="Non-Mod Release By Tag" [disabled]="!nonMods() || nonMods().length === 0">
      <tag-release [releaseLines]="nonMods()" [handChangeAllowed]="handChangeAllowed()" (releaseGenerated)="releaseGenerated($event)"></tag-release>
    </mat-tab>
    <mat-tab label="Release Mods">
      <mod-release [entityKey]="entityKey()" (releaseGenerated)="releaseGenerated($event)"></mod-release>
    </mat-tab>
  </mat-tab-group>
</div>

